// extracted by css-extract-rspack-plugin
export default {"labels":"labels--DChoMNziQ_YzXzK3"};